import ICommand from '../../FrontApplet/Command/ICommand';
import { ITypedCommandEvent } from '../../FrontApplet/Command/ICommandEvent';
import FrontApplet from '../../FrontApplet/FrontApplet';
import { ShowOSDRequest, ShowOSDResult } from './osdCommands';

export function handleOSDRequests(
	onCommand: (callback: (commandEvent: ITypedCommandEvent<ShowOSDRequest>) => Promise<void>) => void,
	dispatch: <TCommand extends ICommand>(command: TCommand) => Promise<void>,
	frontApplet: FrontApplet,
) {
	onCommand(async (commandEvent: ITypedCommandEvent<ShowOSDRequest>) => {
		switch (commandEvent.command.type) {
			case ShowOSDRequest:
				await frontApplet.osd.showOSD();
				await dispatch<ShowOSDResult>({
					type: ShowOSDResult,
					result: {},
				});
				break;
			default:
		}
	});
}
